<template functional>
  <div class="title">
    {{ props.title }}
  </div>
</template>

<script>
export default {
  name: 'CTitle'
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  color: #333;
  font-size: $fontMd;
  line-height: 22px;
  font-weight: bold;

  &::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 22px;
    margin-right: 10px;
    background-color: #6EBEFF;
  }
}
</style>
